import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { handleAxiosError } from "./responses/AxiosResponseHandler";

class RemoveGroupInvitationApi {

    private authClient: AuthClient;
    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async RemoveInvitation(groupId: string, invitedFriendId: string) {

        try {

            const authenticationResponse = this.authClient.getAuthenticationResponse();
            const response = await axios.post(
                `${this.authClient.getApiRoot()}/group/delete-invitation/${groupId}/${invitedFriendId}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${authenticationResponse?.token}`,
                    },
                }
            );

            return {
                statusCode: response.status,
                errorMessage: ""
            };

        } catch (error) {
            const errorResponse = handleAxiosError(error as AxiosError);
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage
            }
        }
    }
}

export default RemoveGroupInvitationApi;
